export const CONNECTION_RETRY_SUCCESS_TITLE =
  "You can now complete your booking.";
export const CONNECTION_RETRY_SUCCESS_SUBTITLE =
  "We were able to reach your hotel. Please review the details below and confirm your booking.";
